import { updateSubscriptionContract } from "../mutations/updateSubscriptionContract.subscriptions.js";
import { SUBSCRIPTION_CONTRACT_META_KEY } from "../constants.js";
import { getSubscriptionContract } from "../index.js";
const CONTRACT_CANCELLED_META_KEYS = [
    SUBSCRIPTION_CONTRACT_META_KEY.CANCEL_REASON,
    SUBSCRIPTION_CONTRACT_META_KEY.CANCEL_SOURCE,
    SUBSCRIPTION_CONTRACT_META_KEY.DO_NOT_SEND_CANCEL_EMAIL,
];
/**
 * Resumes a cancelled subscription contract.
 * - Removes cancellation meta fields.
 * - Sets renewAt and activeUntil to new acceptable dates.
 * @param contract The subscription contract to resume
 * @returns Updated subscription contract
 */
export async function onResumeContract(contractId, renewAt, { client }) {
    const { meta, status } = await getSubscriptionContract({ contractId }, { client });
    const filteredMeta = meta?.filter((meta) => !CONTRACT_CANCELLED_META_KEYS.includes(meta.key)) ??
        [];
    const updatedContract = {
        meta: filteredMeta,
        status: {
            price: status?.phase?.price,
            currency: status?.phase?.currency,
            renewAt,
            activeUntil: renewAt,
        },
    };
    const id = await updateSubscriptionContract({ id: contractId, ...updatedContract }, { client });
    return id;
}
